import {Skill} from "../../generated/graphql";
import {AssignmentState} from "../../providers/AssignmentReducer";
import {getRequirementGap} from "../../utils/assignment/Assignment.utils";
import {AgStop} from "../common/types";

/** A job on an IP route, in the shape the skill mismatch modal and the override notes read. */
export type RouteJob = {
  jobId: number;
  jobNumber: string;
  order: AgStop["order"];
};

/** Skill ids from the comma-separated `skills` string IP drivers carry ("58,54,53"). */
export const parseSkillIds = (skills: string | null | undefined): Array<{id: number}> =>
  (skills ?? "")
    .split(",")
    .map((id) => Number.parseInt(id, 10))
    .filter((id) => !Number.isNaN(id))
    .map((id) => ({id}));

/** One entry per job: a job's pickup and delivery stops share it. */
export const getRouteJobs = (stops: AgStop[]): RouteJob[] =>
  Array.from(
    new Map(
      stops
        .filter((stop) => stop.job?.jobId != null)
        .map((stop) => [stop.job!.jobId, {jobId: stop.job!.jobId, jobNumber: stop.job!.jobNumber, order: stop.order}])
    ).values()
  );

/** The jobs whose active skills the driver does not all hold (DP-3236 rule, skills only). */
export const getSkillGapJobs = (
  jobs: RouteJob[],
  driverSkills: Array<{id: number}>,
  activeSkills: Skill[]
): RouteJob[] =>
  jobs.filter(
    (job) =>
      getRequirementGap({
        order: job.order,
        driver: {skills: driverSkills},
        isSkillsBasedRequirements: true,
        activeSkills
      }).missing.length > 0
  );

// The skill mismatch modal reads only selectedJobs, selectedStops and selectedManifest; the IP map has no
// Dispatch assignment of its own, so the rest stays empty.
export const SKILL_CHECK_ASSIGNMENT_STATE: AssignmentState = {
  selectedJobs: [],
  jobsRequirements: new Map(),
  pendingActions: [],
  selectedManifest: undefined,
  originManifest: undefined,
  selectedStops: [],
  highlightManifests: undefined,
  reassignJobsRequirements: new Map()
};
